<div class="tile">
  <p>
    {{ 'my-home.my-home-page.ad-agree-note.note-1' | transloco }}
  </p>
  <p>
    {{ 'my-home.my-home-page.ad-agree-note.note-2' | transloco }}
  </p>
  <ul class="list font-size-smaller1">
    <li>
      {{ 'my-home.my-home-page.ad-agree-note.note-3' | transloco }}
      <div class="row mt-4">
        <div class="col-12 col-xl-2 col-lg-3 col-sm">
          <web-design-system-button size="small" [fullwidth]="true" (click)="adAgreed()">
            {{ 'my-home.my-home-page.ad-agree-note.btn-agree' | transloco }}
          </web-design-system-button>
        </div>
        <div class="col-12 col-lg-2 col-md-3 mt-md-0 mt-2">
          <web-design-system-button size="small" type="secondary" (click)="showAdAgreeNoteLater()">
            {{ 'my-home.my-home-page.ad-agree-note.btn-later' | transloco }}
          </web-design-system-button>
        </div>
        <div class="col mt-2 d-flex justify-content-end align-items-center pr-3 pr-md-5">
          <a class="link link-underline cursor-pointer" (click)="adAgreeDeclined()">{{
            'my-home.my-home-page.ad-agree-note.btn-decline' | transloco
          }}</a>
        </div>
      </div>
    </li>
  </ul>
</div>
